<div class="content p-5">
  <p class="is-bold is-size-5 color-darkblue has-text-centered">
    Hinweis
  </p>

  <div class="columns mb-0">
    <div class="column line-height-is-2 pb-0">
      <div class="content mb-0">
        <p class="text-wrap-pretty">Im Grundbuch Abteilung II, werden Lasten und Beschränkungen des Grundstücks
          eingetragen.</p>
        <ul class="pl-4 pt-2">
          <li>Dienstbarkeiten (Wegerechte, Leitungsauskünfte)</li>
          <li>Beschränkte persönliche Dienstbarkeiten (z.B. Wohnrechte)</li>
          <li>Grundpfandrechte, soweit sie nicht in der Abteilung III vermerkt sind.</li>
          <li>Vormerkungen und Verfügungsbeschränkungen (z.B. Insolvenzvermerke, Veräußerungsverbote)</li>
        </ul>
        <p>Die Kosten belaufen sich auf <span
            class="is-bold color-darkblue">{{ data.researchDepartmentPricing | number:'1.2-2' }} € (netto)</span> je
          Recherche-Auftrag.</p>
      </div>
    </div>
  </div>

  <hr>

  <ng-container *ngIf="ProductUtils.shouldOpenProductValueDialog([researchDepartmentProduct]) else defaultButtons">
    <app-product-value-form [products]="[researchDepartmentProduct]" [property]="selectedProperty" [hasPadding]="false" (cancelModalEvent)="cancelModal()" (confirmModalEvent)="submitModal()"></app-product-value-form>
  </ng-container>

  <ng-template #defaultButtons>
    <div class="columns">
      <div class="column is-one-third">
        <a class="button back-button has-round-border" (click)="cancelModal()">
          <div class="columns is-align-items-center is-justify-content-center">
            <div class="column is-bold">
              <p class="mb-0">Abbrechen</p>
            </div>
          </div>
        </a>
      </div>
      <div class="column is-one-third"></div>
      <div class="column is-one-third">
        <a class="button buy-button has-round-border" (click)="submitModal()">
          <div class="columns is-align-items-center is-justify-content-center">
            <div class="column is-bold">
              <p class="mb-0">Bestätigen</p>
            </div>
          </div>
        </a>
      </div>
    </div>
  </ng-template>
</div>
